import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Csv Importer", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Event", -1 /* HOISTED */)
const _hoisted_3 = { class: "input-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Event Csv file:", -1 /* HOISTED */)
const _hoisted_5 = { class: "table table-bordered fp-bs-migrate-users" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "End Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Venue Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Space"),
    /*#__PURE__*/_createElementVNode("th", null, "Event Type")
  ])
], -1 /* HOISTED */)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Download an example csv "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/Content/EventExample.csv",
    download: "EventExample.csv",
    target: "_blank"
  }, "here"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" The example csv was generated from "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://docs.google.com/spreadsheets/d/1rwrOfECmHJ8g45ZtSLOC5RBrVkeJQxOuWpAmqxzMsLU/edit?usp=sharing",
      target: "_blank"
    }, "this google sheet")
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("input", {
        type: "file",
        for: "name",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args)))
      }, null, 32 /* HYDRATE_EVENTS */)
    ]),
    _createElementVNode("table", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: event.Title
          }, [
            _createElementVNode("td", null, _toDisplayString(event.Title), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(event.Description), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(event.StartDate.toLocaleString('en-GB')), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(event.EndDate.toLocaleString('en-GB')), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(event.VenueName), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(event.SpaceName), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(event.EventTypeName), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("button", {
      class: "btn",
      disabled: !(_ctx.events && _ctx.events.length > 0),
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addEvents && _ctx.addEvents(...args)), ["prevent"]))
    }, " Upload Event/s to TLC ", 8 /* PROPS */, _hoisted_7),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        href: _ctx.googleSignInLink,
        target: "_blank",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSignedInToGoogle = true))
      }, "Sign in to Google", 8 /* PROPS */, _hoisted_8),
      _createTextVNode(" to be able to create the Google calendar events ")
    ]),
    _createElementVNode("button", {
      class: "btn",
      disabled: !(_ctx.events && _ctx.events.length > 0 && _ctx.isSignedInToGoogle),
      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createGoogleEvents && _ctx.createGoogleEvents(...args)), ["prevent"]))
    }, " Create Google Calendar Event/s ", 8 /* PROPS */, _hoisted_9),
    _hoisted_10,
    _hoisted_11,
    _hoisted_12
  ], 64 /* STABLE_FRAGMENT */))
}